// /* eslint-disable import/no-anonymous-default-export */

import FinalWrapUp from "./finalWrapUp";
import JourneyJournal from "./journeyJournal";
import JourneyQuiz from "./journeyQuiz";

const TemplateReviewIndex = ({
  index,
  data,
  stepId,
  handleEditForm,
  editTemplate,
  dataLoading,
  refetchStepDetail,
}) => {
  const templateId = index;
  const props = {
    templateId,
    data,
    stepId,
    handleEditForm,
    editTemplate,
    dataLoading,
    refetchStepDetail,
  };
  const tempArr = [
    <JourneyQuiz props={props} />,
    <JourneyJournal props={props} />,
    <FinalWrapUp props={props} />,
  ];

  return tempArr[index];
};

export default TemplateReviewIndex;
